import { OnboardingBanner } from 'components/Onboarding/OnboardingBanner';
import { OnboardingSheet } from 'components/Onboarding/OnboardingSheet';
import { CorporateViewTabGroup } from './CorporateViewTabGroup';
import { UscgMapLayout } from './UscgMapLayout';

export default function MapPage() {
  return (
    <div className="iap-response">
      <div className="maincontent-no-padding iap-response__main">
        <UscgMapLayout>
          <CorporateViewTabGroup
            currentMode={''}
            updateMode={() => {}}
            currentPhase={0}
          />
        </UscgMapLayout>
      </div>
      <OnboardingSheet />
      <OnboardingBanner />
    </div>
  );
}
